<template>
  <Loader v-if="loadingAgeingOfReceivables"></Loader>
  <div v-else>
    <div class="alert alert-danger ml-3 mr-3" role="alert">
      <p class="danger">{{$t('views.agreements.show.ageOfReceivablesInfo')}}</p>
    </div>
    <vue-chart type="line" :data="valuesChartData" :options="chartOptions"
               style="position:relative;width: 100%;height: 200px;"></vue-chart>
    <hr>
    <table class="table table-sm table-responsive-md table-striped table-hover">
      <thead>
      <tr>
        <th>{{ $t('tableHeadings.dateOperation') }}</th>
        <th>{{ $t('views.agreements.show.payments') }}</th>
        <th>{{ $t('views.agreements.show.paymentsMades') }}</th>
        <th>{{ $t('views.agreements.show.debt') }}</th>
        <th>{{ $t('tableHeadings.delayDays') }}</th>
        <th>{{$t('tableHeadings.interestValue')}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in ageOfReceivables" :key="index">
        <td>
          {{ item.date }}
        </td>
        <td>
          {{ item.payments }}
        </td>
        <td>
          {{ item.paymentsMades }}
        </td>
        <td>
          {{ item.debt }}
        </td>
        <td>
          {{ item.delayDays }}
        </td>
        <td>
          {{ item.interestValue }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import VueChart from 'vue-chart-js'
import ApiService from '@/utils/ApiService'

export default {
  name: 'AgeingOfReceivables',
  components: { Loader, VueChart },
  props: ['idAgreement'],
  data () {
    return {
      loadingAgeingOfReceivables: true,
      ageOfReceivables: [],
      valuesChartData: {
        labels: [],
        datasets: [
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.agreements.show.payments'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(0, 0, 256)',
            backgroundColor: 'rgba(27, 126, 193, 0.1)'
          },
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.agreements.show.paymentsMades'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(0, 128, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)'
          },
          {
            type: 'line',
            steppedLine: false,
            lineTension: 0.1,
            label: this.$t('views.agreements.show.debt'),
            data: [],
            pointRadius: 2,
            fill: false,
            borderColor: 'rgb(255, 0, 0)',
            backgroundColor: 'rgba(255, 0, 0, 0.1)'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        legend: {
          display: true
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false
              // display: false
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0)'
            }
          }]
        }
      }
    }
  },
  created () {
    this.fetchAgeingOfReceivables()
  },
  methods: {
    async fetchAgeingOfReceivables () {
      this.loadingAgeingOfReceivables = true
      let response = await new ApiService(this.idAgreement + '/ageingofreceivables').getResults()
      if (response && response.tableData) {
        this.ageOfReceivables = response.tableData
        this.valuesChartData.datasets[0].data = []
        this.valuesChartData.datasets[1].data = []
        this.valuesChartData.datasets[2].data = []
        this.valuesChartData.labels = []
        for (let i in response.chartData) {
          this.valuesChartData.labels.push(response.chartData[i].date)
          this.valuesChartData.datasets[0].data.push(response.chartData[i].payments)
          this.valuesChartData.datasets[1].data.push(response.chartData[i].paymentsMades)
          this.valuesChartData.datasets[2].data.push(response.chartData[i].debt)
        }
      }
      this.loadingAgeingOfReceivables = false
    }
  }
}
</script>
